export enum MinimapBaseLayer {
    OSM = 0,
    WMS = 1,
    BING = 2,
}